import React, { useState, useEffect, useCallback } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Home from "../Home";
import Maintenance from "../Maintenance";
import { Accordion, Card, Spinner } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb";
import errorMessages from "../../common/errorMessages";
import { FRONT_URL } from "../../config/config";
import _ from "lodash";
import {
  fetchNoticeList,
  fetchStateList,
  fetchCityList,
  fetchAllocatedSalesOfficeList,
  fetchClassificationsList,
  fetchUltmarcFacilitySuperTypeList,
  fetchUltmarcFacilityTypeList,
  fetchMedicalSpecialitySuperTypeList,
  fetchMedicalSpecialityTypeList,
  fetchBUList,
  fetchBranchList,
  fetchDivisionList,
  fetchSalesOfficeList,
  getAllocatedMR,
  getOrganizationInquiryList,
} from "./actions";
import { Select } from "antd";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function OrganizationCustomer(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [activeEmployeeSearch, setActiveEmployeeSearch] =
    useState("esearch-box");
  const [prefectureList, setPrefectureList] = useState([]);
  const [allocatedSalesOfficeList, setAllocatedSalesOfficeList] = useState([]);
  const [hundredBedsList, setHundredBedsList] = useState([]);
  const [facilityClassList, setFacilityClassList] = useState([]);
  const [facilityFunctionList, setFacilityFunctionList] = useState([]);
  const [ultmarcRecordList, setUltmarcRecordList] = useState([]);
  const [ultmarcHospitalList, setUltmarcHospitalList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [ultmarcFacilitySuperTypeList, setUltmarcFacilitySuperTypeList] =
    useState("");
  const [ultmarcFacilityTypeList, setUltmarcFacilityTypeList] = useState("");
  const [medicalSpecialitySuperTypeList, setMedicalSpecialitySuperTypeList] =
    useState("");
  const [medicalSpecialityTypeList, setMedicalSpecialityTypeList] =
    useState("");
  const [cityData, setCityData] = useState([]);
  const [buList, setBuList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);
  const [mrList, setMRList] = useState([]);
  const [selectedMRList, setSelectedMRList] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [prefectureID, setPrefectureID] = useState("");
  const [cityID, setCityID] = useState([]);
  const [allocatedSalesOfficeID, setAllocatedSalesOfficeID] = useState("");
  const [hundredBedID, setHundredBedID] = useState("");
  const [customerTypeID, setCustomerTypeID] = useState("");
  const [ultmarcRecordID, setUltmarcRecordID] = useState("");
  const [ultmarcHospitalID, setUltmarcHospitalID] = useState("");
  const [facilityFunctionID, setFacilityFunctionID] = useState("");
  const [facilityClassID, setFacilityClassID] = useState("");
  const [ultmarcFacilitySuperTypeID, setUltmarcFacilitySuperTypeID] =
    useState("");
  const [ultmarcFacilityTypeID, setUltmarcFacilityTypeID] = useState("");
  const [ultmarcFacilityTypeName, setUltmarcFacilityTypeName] = useState("");
  const [medicalSpecialitySuperTypeID, setMedicalSpecialitySuperTypeID] =
    useState("");
  const [medicalSpecialityTypeID, setMedicalSpecialityTypeID] = useState("");
  const [medicalSpecialityTypeName, setMedicalSpecialityTypeName] =
    useState("");
  const [buValue, setBuValue] = useState("");
  const [division, setDivision] = useState("");
  const [branch, setBranch] = useState("");
  const [salesOffice, setSalesOffice] = useState("");
  const [buID, setBuID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [divisionID, setDivisionID] = useState("");
  const [salesOfficeID, setSalesOfficeID] = useState("");
  const [facilityKanjiName, setFacilityKanjiName] = useState("");
  const [facilityKanaName, setFacilityKanaName] = useState("");
  const [integratedCustomerCode, setIntegratedCustomerCode] = useState("");
  const [freeAddress, setFreeAddress] = useState("");
  const [telephone, setTelephone] = useState("");
  const [wwid, setWWID] = useState("");
  const [name, setName] = useState("");
  const [noData, setNoData] = useState(false);
  const [noEmployeeData, setNoEmployeeData] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [limit, setLimit] = useState(40);
  const [employeeLimit, setEmployeeLimit] = useState(40);
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState();
  const [lazyLoading, setLazyLoading] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const [employeeLoading, setEmployeeLoading] = useState();
  const [totalOrgCustomers, setTotalOrgCustomers] = useState();
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [errors, setErrors] = useState({});
  const [employeeErrors, setEmployeeErrors] = useState({});
  const [applyNotice, setApplyNotice] = useState(false);
  const [orgLazyLoadData, setOrgLazyLoadData] = useState({});
  const [employeeLazyLoadData, setEmployeeLazyLoadData] = useState({});

  const [prefectureLoading, setPrefectureLoading] = useState(false);
  const [allocatedSalesLoading, setAllocatedSalesLoading] = useState(false);
  const [ultmarcRecordLoading, setUltmarcRecordLoading] = useState(false);
  const [customerTypeLoading, setCustomerTypeLoading] = useState(false);
  const [hundredBedsLoading, setHundredBedsLoading] = useState(false);
  const [facilityClassLoading, setFacilityClassLoading] = useState(false);
  const [facilityFunctionLoading, setFacilityFunctionLoading] = useState(false);
  const [ultmarcHospitalLoading, setUltmarcHospitalLoading] = useState(false);
  const [ultmarcFailityOneLoading, setUltmarcFacilityOneLoading] =
    useState(false);
  const [ultmarcFacilityTwoLoading, setUltmarcFacilityTwoLoading] =
    useState(false);
  const [specialityOneLoading, setSpecialityOneLoading] = useState(false);
  const [specialityTwoLoading, setSpecialityTwoLoading] = useState(false);

  const [sortCode, setSortCode] = useState("asc");
  const [sortFacilityName, setSortFacilityName] = useState("asc");
  const [sortAddress, setSortAddress] = useState("asc");
  const [sortTelephone, setSortTelephone] = useState("asc");
  const [sortCustomerType, setSortCustomerType] = useState("asc");
  const [sortFacilityClass, setSortFacilityClass] = useState("asc");

  const options = [
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Option3", label: "Option3" },
    { value: "Option4", label: "Option4" },
  ];

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "",
    },
  ];

  useEffect(() => {
    document.body.classList.add("sidebar-open");
    const token = sessionStorage.getItem("token");
    if (token) {
      !sessionStorage.getItem("Prefecture")
        ? getPrefecture()
        : setPrefectureList(JSON.parse(sessionStorage.getItem("Prefecture")));
      !sessionStorage.getItem("Allocated sales office")
        ? getAllocatedSalesOfficesList()
        : setAllocatedSalesOfficeList(
            JSON.parse(sessionStorage.getItem("Allocated sales office"))
          );
      !sessionStorage.getItem("Ultmarc facility super type")
        ? getUltmarcFacilitySuperType()
        : setUltmarcFacilitySuperTypeList(
            JSON.parse(sessionStorage.getItem("Ultmarc facility super type"))
          );
      !sessionStorage.getItem("Medical speciality super type")
        ? getMedicalSpecialitySuperType()
        : setMedicalSpecialitySuperTypeList(
            JSON.parse(sessionStorage.getItem("Medical speciality super type"))
          );
      !sessionStorage.getItem("BU")
        ? getBUList()
        : setBuList(JSON.parse(sessionStorage.getItem("BU")));

      if (
        !sessionStorage.getItem("jp_person_notice") ||
        !sessionStorage.getItem("jp_org_notice") ||
        !sessionStorage.getItem("en_person_notice") ||
        !sessionStorage.getItem("en_affiliation_notice") ||
        !sessionStorage.getItem("jp_affiliation_notice") ||
        !sessionStorage.getItem("en_org_noticen")
      ) {
        getNoticeListing();
      }
      if (
        !sessionStorage.getItem("Hundred beds") ||
        !sessionStorage.getItem("Facility class") ||
        !sessionStorage.getItem("Ultmarc hospital") ||
        !sessionStorage.getItem("Ultmarc record") ||
        !sessionStorage.getItem("Customer type") ||
        !sessionStorage.getItem("Facility function")
      ) {
        getClassification();
      } else {
        const hundredBeds = sessionStorage.getItem("Hundred beds");
        const ultmarcHospital = sessionStorage.getItem("Ultmarc hospital");
        const ultmarcRecord = sessionStorage.getItem("Ultmarc record");
        const customerType = sessionStorage.getItem("Customer type");
        const facilityClass = sessionStorage.getItem("Facility class");
        const facilityFunction = sessionStorage.getItem("Facility function");
        setHundredBedsList(JSON.parse(hundredBeds));
        setUltmarcHospitalList(JSON.parse(ultmarcHospital));
        setUltmarcRecordList(JSON.parse(ultmarcRecord));
        setCustomerTypeList(JSON.parse(customerType));
        setFacilityClassList(JSON.parse(facilityClass));
        setFacilityFunctionList(JSON.parse(facilityFunction));
      }
    }
  }, []);

  const getNoticeListing = async () => {
    await fetchNoticeList().then((response) => {
      sessionStorage.setItem("translation", JSON.stringify(response));
      sessionStorage.setItem(
        "en_org_notice",
        response.fe_text_for_notice_organizationcustomer_en
      );
      sessionStorage.setItem(
        "jp_org_notice",
        response.fe_text_for_notice_organizationcustomer_ja
      );
      sessionStorage.setItem(
        "en_person_notice",
        response.fe_text_for_notice_personcustomer_dcr_en
      );
      sessionStorage.setItem(
        "jp_person_notice",
        response.fe_text_for_notice_personcustomer_dcr_ja
      );
      sessionStorage.setItem(
        "en_affiliation_notice",
        response.fe_text_for_notice_customeraffiliation_en
      );
      sessionStorage.setItem(
        "jp_affiliation_notice",
        response.fe_text_for_notice_customeraffiliation_ja
      );
    });
  };

  const getPrefecture = async () => {
    setPrefectureLoading(true);
    await fetchStateList().then((res) => {
      setPrefectureLoading(false);
      let newState = [];
      for (let index = 0; index < res.length; index++) {
        const serviceOne = res[index];
        newState.push({
          value: serviceOne.stateID,
          label: serviceOne.stateName,
        });
      }
      setPrefectureList(newState);
      sessionStorage.setItem("Prefecture", JSON.stringify(newState));
    });
  };

  /*** 
  @purpose : Get allocated sales office list
  @Parameter : {}
  **/
  const getAllocatedSalesOfficesList = async () => {
    setAllocatedSalesLoading(true);
    await fetchAllocatedSalesOfficeList().then((res) => {
      setAllocatedSalesLoading(false);
      let newList = [];
      if (res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.allocatedSalesOfficeID,
            label: item.orgName,
          });
        }
        sessionStorage.setItem(
          "Allocated sales office",
          JSON.stringify(newList)
        );
        setAllocatedSalesOfficeList(newList);
      }
    });
  };

  /*** 
  @purpose : Get classification list
  @Parameter : {}
  **/
  const getClassification = async () => {
    setHundredBedsLoading(true);
    setFacilityClassLoading(true);
    setUltmarcRecordLoading(true);
    setUltmarcHospitalLoading(true);
    setCustomerTypeLoading(false);
    setFacilityFunctionLoading(false);
    await fetchClassificationsList().then((res) => {
      let bedList = [];
      let facClassList = [];
      let ultRecordList = [];
      let ultHospitalList = [];
      let custTypeList = [];
      let facFunctionList = [];
      if (res && res.hundredBeds) {
        if (res.hundredBeds.length > 0) {
          setHundredBedsLoading(false);
          for (let index = 0; index < res.hundredBeds.length; index++) {
            const item = res.hundredBeds[index];
            bedList.push({
              value: item.hundredBedsType,
              label: item.hundredBedsTypeName,
            });
          }
          sessionStorage.setItem("Hundred beds", JSON.stringify(bedList));
          setHundredBedsList(bedList);
        }
      }
      if (res && res.facilityClass) {
        if (res.facilityClass.length > 0) {
          setFacilityClassLoading(false);
          for (let index = 0; index < res.facilityClass.length; index++) {
            const item = res.facilityClass[index];
            facClassList.push({
              value: item.facilityClassType,
              label: item.facilityClassTypeName,
            });
          }
          sessionStorage.setItem(
            "Facility class",
            JSON.stringify(facClassList)
          );
          setFacilityClassList(facClassList);
        }
      }
      if (res && res.ultmarcHospital) {
        if (res.ultmarcHospital.length > 0) {
          setUltmarcHospitalLoading(false);
          for (let index = 0; index < res.ultmarcHospital.length; index++) {
            const item = res.ultmarcHospital[index];
            ultHospitalList.push({
              value: item.ultmarcHospitalType,
              label: item.ultmarcHospitalTypeName,
            });
          }
          sessionStorage.setItem(
            "Ultmarc hospital",
            JSON.stringify(ultHospitalList)
          );
          setUltmarcHospitalList(ultHospitalList);
        }
      }
      if (res && res.ultmarcRecord) {
        if (res.ultmarcRecord) {
          setUltmarcRecordLoading(false);
          for (let index = 0; index < res.ultmarcRecord.length; index++) {
            const item = res.ultmarcRecord[index];
            ultRecordList.push({
              value: item.ultmarcRecordID,
              label: item.ultmarcRecordIDName,
            });
          }
          sessionStorage.setItem(
            "Ultmarc record",
            JSON.stringify(ultRecordList)
          );
          setUltmarcRecordList(ultRecordList);
        }
      }
      if (res && res.custType) {
        if (res.custType.length > 0) {
          setCustomerTypeLoading(false);
          for (let index = 0; index < res.custType.length; index++) {
            const item = res.custType[index];
            custTypeList.push({
              value: item.custTypeID,
              label: item.customerTypeNameLocal,
            });
          }
          sessionStorage.setItem("Customer type", JSON.stringify(custTypeList));
          setCustomerTypeList(custTypeList);
        }
      }
      if (res && res.facilityFunction) {
        if (res.facilityFunction.length > 0) {
          setFacilityFunctionLoading(false);
          for (let index = 0; index < res.facilityFunction.length; index++) {
            const item = res.facilityFunction[index];
            facFunctionList.push({
              value: item.facilityFunctionType,
              label: item.facilityFunctionTypeName,
            });
          }
          sessionStorage.setItem(
            "Facility function",
            JSON.stringify(facFunctionList)
          );
          setFacilityFunctionList(facFunctionList);
        }
      }
    });
  };

  /*** 
  @purpose : Get ultmarc facility sup[er type list
  @Parameter : {}
  **/
  const getUltmarcFacilitySuperType = async () => {
    setUltmarcFacilityOneLoading(true);
    await fetchUltmarcFacilitySuperTypeList().then((res) => {
      setUltmarcFacilityOneLoading(false);
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.facilityTypeOneID,
          label: item.ultmarcFacilityTypeNameLocalOne,
        });
      }
      sessionStorage.setItem(
        "Ultmarc facility super type",
        JSON.stringify(newList)
      );
      setUltmarcFacilitySuperTypeList(newList);
    });
  };

  /*** 
  @purpose : Get medical spexciality super type
  @Parameter : {}
  **/
  const getMedicalSpecialitySuperType = async () => {
    setSpecialityOneLoading(true);
    await fetchMedicalSpecialitySuperTypeList().then((res) => {
      setSpecialityOneLoading(false);
      let newList = [];
      if (res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.medicalSpecialityOneID,
            label: item.medicalSpecialityNameLocalOne,
          });
        }
        sessionStorage.setItem(
          "Medical speciality super type",
          JSON.stringify(newList)
        );
        setMedicalSpecialitySuperTypeList(newList);
      }
    });
  };

  /*** 
  @purpose : Get BU list
  @Parameter : {}
  **/
  const getBUList = async () => {
    await fetchBUList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.buID, label: item.orgName });
      }
      sessionStorage.setItem("BU", JSON.stringify(newList));
      setBuList(newList);
    });
  };

  const loadRecords = async () => {
    let body = {
      customerNameLocal: orgLazyLoadData.customerNameLocal,
      customerNameLocalKana: orgLazyLoadData.customerNameLocalKana,
      unifiedCustomerCode: orgLazyLoadData.unifiedCustomerCode,
      stateID: orgLazyLoadData.stateID,
      cityID: orgLazyLoadData.cityID,
      freeTextAdd: orgLazyLoadData.freeTextAdd,
      allocatedSalesOfficeID: orgLazyLoadData.allocatedSalesOfficeID,
      empID: orgLazyLoadData.empID,
      tel: orgLazyLoadData.tel,
      custTypeID: orgLazyLoadData.custTypeID,
      ultmarcRecordID: orgLazyLoadData.ultmarcRecordID,
      hundredBedsType: orgLazyLoadData.hundredBedsType,
      facilityFunctionType: orgLazyLoadData.facilityFunctionType,
      facilityClassType: orgLazyLoadData.facilityClassType,
      ultmarcHospitalType: orgLazyLoadData.ultmarcHospitalType,
      facilityTypeOneID: orgLazyLoadData.facilityTypeOneID,
      facilityTypeTwoID: orgLazyLoadData.facilityTypeTwoID,
      medicalSpecialityOneID: orgLazyLoadData.medicalSpecialityOneID,
      medicalSpecialityTwoID: orgLazyLoadData.medicalSpecialityTwoID,
      limit: organizationList.length,
      totalRecords: totalOrgCustomers,
    };
    if (organizationList.length < totalOrgCustomers) {
      setLazyLoading(true);
      await getOrganizationInquiryList(body).then((response) => {
        let list = [];
        let facility = "";
        var result =
          response &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            facilityClassList.map((fac) => {
              if (fac.value === o.facilityClassType) {
                facility = fac.label;
              }
            });
            o.facilityClassName = facility;
            return o;
          });
        list = organizationList.concat(result);
        setLazyLoading(false);
        setOrganizationList(list);
      });
      setLimit(limit + 10);
    }
  };

  // const handleContainerOnBottom = useCallback(async () => {
  //   console.log("called");
  //   let body = {
  //     customerNameLocal: orgLazyLoadData.customerNameLocal,
  //     customerNameLocalKana: orgLazyLoadData.customerNameLocalKana,
  //     unifiedCustomerCode: orgLazyLoadData.unifiedCustomerCode,
  //     stateID: orgLazyLoadData.stateID,
  //     cityID: orgLazyLoadData.cityID,
  //     freeTextAdd: orgLazyLoadData.freeTextAdd,
  //     allocatedSalesOfficeID: orgLazyLoadData.allocatedSalesOfficeID,
  //     empID: orgLazyLoadData.empID,
  //     tel: orgLazyLoadData.tel,
  //     custTypeID: orgLazyLoadData.custTypeID,
  //     ultmarcRecordID: orgLazyLoadData.ultmarcRecordID,
  //     hundredBedsType: orgLazyLoadData.hundredBedsType,
  //     facilityFunctionType: orgLazyLoadData.facilityFunctionType,
  //     facilityClassType: orgLazyLoadData.facilityClassType,
  //     ultmarcHospitalType: orgLazyLoadData.ultmarcHospitalType,
  //     facilityTypeOneID: orgLazyLoadData.facilityTypeOneID,
  //     facilityTypeTwoID: orgLazyLoadData.facilityTypeTwoID,
  //     medicalSpecialityOneID: orgLazyLoadData.medicalSpecialityOneID,
  //     medicalSpecialityTwoID: orgLazyLoadData.medicalSpecialityTwoID,
  //     limit: organizationList.length,
  //     totalRecords: totalOrgCustomers,
  //   };
  //   if (
  //     organizationList.length <= totalOrgCustomers
  //     // && totalOrgCustomers >= 30
  //   ) {
  //     console.log("total", totalOrgCustomers);
  //     await getOrganizationInquiryList(body).then((response) => {
  //       let list = [];
  //       let facility = "";
  //       var result =
  //         response &&
  //         response.data.map(function (el) {
  //           var o = Object.assign({}, el);
  //           facilityClassList.map((fac) => {
  //             if (fac.value === o.facilityClassType) {
  //               facility = fac.label;
  //             }
  //           });
  //           o.facilityClassName = facility;
  //           return o;
  //         });
  //       list = organizationList.concat(result);
  //       setOrganizationList(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // }, [organizationList, limit]);

  const handleEmployeeContainerOnBottom = async () => {
    let body = {
      buID: employeeLazyLoadData.buID,
      divisionID: employeeLazyLoadData.divisionID,
      branchID: employeeLazyLoadData.branchID,
      salesOfficeID: employeeLazyLoadData.salesOfficeID,
      wwid: employeeLazyLoadData.wwid,
      mrName: employeeLazyLoadData.mrName,
      limit: employeeLimit,
    };
    if (mrList.length < totalEmployees) {
      await getAllocatedMR(body).then((response) => {
        if (response !== null) {
          var result =
            response &&
            response.map(function (el) {
              var o = Object.assign({}, el);
              o.isChecked = false;
              return o;
            });
          let list = [];
          list = mrList.concat(result);
          setMRList(list);
          setEmployeeLoading(false);
        } else {
          setMRList(mrList);
        }
      });
      setEmployeeLimit(employeeLimit + 10);
    }
  };

  /*** 
  @purpose : Open employee search
  @Parameter : {}
  **/
  const openEmployeeSearch = () => {
    setActiveEmployeeSearch(
      activeEmployeeSearch === "esearch-box"
        ? "esearch-box active"
        : "esearch-box"
    );
  };

  /*** 
  @purpose : Add employee search
  @Parameter : {}
  **/
  const addEmployeeSearch = () => {
    let selected = [];
    mrList.map((mr) => {
      if (mr.isChecked == true) {
        selected.push(mr);
      }
    });
    let id = [];
    let name = [];
    selected.map((s) => id.push(s.wwid));
    selected.map((s) => name.push(s.mrName));
    setSelectedMRList(selected);
    setActiveEmployeeSearch(
      activeEmployeeSearch === "esearch-box"
        ? "esearch-box active"
        : "esearch-box"
    );
  };

  /*** 
  @purpose : Remove employee
  @Parameter : {emp}
  **/
  const removeEmployee = (emp) => {
    let list = selectedMRList.filter((s) => s !== emp);
    setSelectedMRList(list);
  };

  /*** 
  @purpose : Validate employee form
  @Parameter : {}
  **/
  const validateEmployeeForm = () => {
    let isFormValid = true;
    setApplyNotice(false);
    let pattern = new RegExp(/[<(.|\n*?)>]/);
    let errors = {
      name: "",
    };
    if (facilityKanjiName && pattern.test(name) === true)
      errors.facilityKanjiName = errorMessages.VALID_NAME;
    else errors.name = "";

    if (errors.name !== "") {
      isFormValid = false;
    } else if (
      buID === "" &&
      divisionID === "" &&
      branchID === "" &&
      salesOfficeID === "" &&
      wwid === "" &&
      name === ""
    ) {
      isFormValid = false;
      setApplyNotice(true); 
    } else {
      isFormValid = true;
    }

    setEmployeeErrors(errors);

    return isFormValid;
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);
  const employeeContainerRef = useBottomScrollListener(
    handleEmployeeContainerOnBottom
  );

  /*** 
  @purpose : Handle employee search
  @Parameter : {}
  **/
  const handleEmployeeSearch = async () => {
    if (validateEmployeeForm()) {
      setEmployeeLoading(true);
      setNoEmployeeData(false);
      const body = {
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        salesOfficeID: salesOfficeID,
        wwid: wwid,
        mrName: name,
      };
      setEmployeeLazyLoadData(body);
      await getAllocatedMR(body).then((response) => {
        if (response.success === true && response.data !== null) {
          var result =
            response &&
            response.data.map(function (el) {
              var o = Object.assign({}, el);
              o.isChecked = false;
              return o;
            });
          setMRList(result);
          setEmployeeLoading(false);
          setNoEmployeeData(false);
        }
        if (
          (response.success === true && response.data.length === 0) ||
          response.success === false
        ) {
          setLoading(false);
          setNoEmployeeData(true);
          setMRList([]);
        }
      });
    }
  };

  /*** 
  @purpose : Validate org inquiry form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z]+|[ａ-ｚＡ-Ｚ]+[々〆〤]+/
    );
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let address = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let numbers = new RegExp(/[0-9]/);
    let errors = {
      facilityKanjiName: "",
      facilityKanaName: "",
      integratedCustomerCode: "",
      freeAddress: "",
      telephone: "",
    };
    if (facilityKanjiName && pattern.test(facilityKanjiName) === true)
      errors.facilityKanjiName = "errorMessages.VALID_KANJI_FACILITY_NAME";
    else errors.facilityKanjiName = "";

    if (facilityKanaName && kanaRegex.test(facilityKanaName) === false)
      errors.facilityKanaName = "errorMessages.VALID_KANA_FACILITY_NAME";
    else errors.facilityKanaName = "";

    if (integratedCustomerCode && !address.test(integratedCustomerCode))
      errors.integratedCustomerCode = "errorMessages.VALID_INTEGRATED_CODE";
    else if (integratedCustomerCode && pattern.test(integratedCustomerCode))
      errors.integratedCustomerCode = "errorMessages.VALID_INTEGRATED_CODE";
    else errors.integratedCustomerCode = "";

    if (telephone && numbers.test(telephone) === false)
      errors.telephone = "errorMessages.VALID_NUMBER";
    else errors.telephone = "";

    if (
      errors.facilityKanjiName !== "" ||
      errors.facilityKanaName ||
      errors.integratedCustomerCode ||
      errors.telephone
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Handle Organization Search
  @Parameter : {}
  **/
  const handleOrganizationSearch = async () => {
    if (validateForm()) {
      setIsLoading(true);
      setLoading(true);
      setNoData(false);
      let list = [];
      selectedMRList.map((mr) => list.push(mr.wwid));
      let cityIdArray = [];
      cityID.forEach((item) => {
        cityIdArray.push(item.value);
      });
      let body = {
        customerNameLocal: facilityKanjiName,
        customerNameLocalKana: facilityKanaName,
        unifiedCustomerCode: integratedCustomerCode,
        stateID: prefectureID,
        cityID: cityIdArray,
        freeTextAdd: freeAddress,
        allocatedSalesOfficeID: allocatedSalesOfficeID,
        empID: list,
        tel: telephone,
        custTypeID: customerTypeID,
        ultmarcRecordID: ultmarcRecordID,
        hundredBedsType: hundredBedID,
        facilityFunctionType: facilityFunctionID,
        facilityClassType: facilityClassID,
        ultmarcHospitalType: ultmarcHospitalID,
        facilityTypeOneID: ultmarcFacilitySuperTypeID,
        facilityTypeTwoID: ultmarcFacilityTypeID,
        medicalSpecialityOneID: medicalSpecialitySuperTypeID,
        medicalSpecialityTwoID: medicalSpecialityTypeID,
        limit: 0,
        totalRecords: 0,
      };
      setOrgLazyLoadData(body);
      await getOrganizationInquiryList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setIsLoading(false);
            setLoading(false);
            setNoData(true);
            setOrganizationList([]);
          }
          if (response.success === true && response.data.length > 0) {
            setIsLoading(false);
            setLoading(false);
            let facility = "";
            var result =
              response &&
              response.data.map(function (el) {
                var o = Object.assign({}, el);
                facilityClassList &&
                  facilityClassList.map((fac) => {
                    if (fac.value === o.facilityClassType) {
                      facility = fac.label;
                    }
                  });
                o.facilityClassName = facility;
                if (o.facilityName === null) {
                  o.facilityName = "";
                }
                if (o.customerCode === null) {
                  o.customerCode = "";
                }
                return o;
              });
            setTotalOrgCustomers(response.data && response.data[0].total);
            setOrganizationList(result);
            setNoData(false);
          }
        }
      });
    }
  };

  /*** 
  @purpose : Handle Organization Details redirection
  @Parameter : {orgID}
  **/
  const handleOrganizationDetails = (orgID) => {
    // history.push(`/organizationInfo?orgId=${orgID}`);
    window.open(FRONT_URL + `/organizationInfo?orgId=${orgID}`, "_blank");
  };

  /*** 
  @purpose : Handle State change
  @Parameter : {value}
  **/
  const handleStateChange = async (value) => {
    if (value) {
      let id = value.value;
      setPrefectureID(id);
      await fetchCityList(id).then((res) => {
        let newCity = [];
        for (let index = 0; index < res.length; index++) {
          const cityOne = res[index];

          newCity.push({ value: cityOne.cityID, label: cityOne.cityName });
        }
        setCityData(newCity);
      });
    } else if (value === null) {
      setPrefectureID("");
      setCityID([]);
    }
  };

  /*** 
  @purpose : Handle city change
  @Parameter : {value}
  **/
  const handleCityChange = async (value) => {
    setCityID(value);
  };

  /*** 
  @purpose : Handle allocated sales office change
  @Parameter : {value}
  **/
  const handleAllocatedSalesOfficeChange = (value) => {
    if (value) {
      const id = value.value;
      setAllocatedSalesOfficeID(id);
    } else {
      setAllocatedSalesOfficeID("");
    }
  };

  /*** 
  @purpose : Handle bed change
  @Parameter : {value}
  **/
  const handleBedChange = async (value) => {
    if (value) {
      const id = value.value;
      setHundredBedID(id);
    } else {
      setHundredBedID("");
    }
  };

  /*** 
  @purpose : Handle customer type change
  @Parameter : {value}
  **/
  const handleCustomerTypeChange = async (value) => {
    if (value) {
      const id = value.value;
      setCustomerTypeID(id);
    } else {
      setCustomerTypeID("");
    }
  };

  /*** 
  @purpose : Handle Ultmarc record change
  @Parameter : {value}
  **/
  const handleUltmarcRecordChange = async (value) => {
    if (value) {
      const id = value.value;
      setUltmarcRecordID(id);
    } else {
      setUltmarcRecordID("");
    }
  };

  /*** 
  @purpose : handle ultmarc hospital change
  @Parameter : {value}
  **/
  const handleUltmarcHospitalChange = async (value) => {
    if (value) {
      const id = value.value;
      setUltmarcHospitalID(id);
    } else {
      setUltmarcHospitalID("");
    }
  };

  /*** 
  @purpose : Handle facility function change
  @Parameter : {value}
  **/
  const handleFacilityFunctionChange = async (value) => {
    if (value) {
      const id = value.value;
      setFacilityFunctionID(id);
    } else {
      setFacilityFunctionID("");
    }
  };

  /*** 
  @purpose : Handle facility class change
  @Parameter : {value}
  **/
  const handleFacilityClassChange = async (value) => {
    if (value) {
      const id = value.value;
      setFacilityClassID(id);
    } else {
      setFacilityClassID("");
    }
  };

  /*** 
  @purpose : Handle ultmarc fcaility super type change
  @Parameter : {value}
  **/
  const handleUltmarcFacilitySuperTypeChange = async (value) => {
    if (value) {
      setUltmarcFacilityTwoLoading(true);
      let id = value.value;
      setUltmarcFacilitySuperTypeID(id);
      await fetchUltmarcFacilityTypeList(id).then((res) => {
        setUltmarcFacilityTwoLoading(false);
        let newList = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.facilityTypeTwoID,
            label: item.ultmarcFacilityTypeNameLocalTwo,
          });
        }
        setUltmarcFacilityTypeList(newList);
      });
    } else {
      setUltmarcFacilityTwoLoading(false);
      setUltmarcFacilitySuperTypeID("");
      setUltmarcFacilityTypeID("");
      setUltmarcFacilityTypeName("");
    }
  };

  /*** 
  @purpose : Handle ultmarc facility type change
  @Parameter : {value}
  **/
  const handleUltmarcFacilityTypeChange = async (value) => {
    if (value) {
      const id = value.value;
      setUltmarcFacilityTypeID(id);
      setUltmarcFacilityTypeName(value.label);
    } else {
      setUltmarcFacilityTypeID("");
      setUltmarcFacilityTypeName();
    }
  };

  /*** 
  @purpose : Handle medical speciality super type change
  @Parameter : {value}
  **/
  const handleMedicalSpecialitySuperTypeChange = async (value) => {
    if (value) {
      setSpecialityTwoLoading(true);
      let id = value.value;
      setMedicalSpecialitySuperTypeID(id);
      await fetchMedicalSpecialityTypeList(id).then((res) => {
        setSpecialityTwoLoading(false);
        let newList = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.medicalSpecialityTwoID,
            label: item.medicalSpecialityNameLocalTwo,
          });
        }
        setMedicalSpecialityTypeList(newList);
      });
    } else {
      setSpecialityTwoLoading(false);
      setMedicalSpecialitySuperTypeID("");
      setMedicalSpecialityTypeID("");
      setMedicalSpecialityTypeName("");
    }
  };

  /*** 
  @purpose : Handle medical speciality type change
  @Parameter : {value}
  **/
  const handleMedicalSpecialityTypeChange = async (value) => {
    if (value) {
      const id = value.value;
      setMedicalSpecialityTypeID(id);
      setMedicalSpecialityTypeName(value.label);
    } else {
      setMedicalSpecialityTypeID("");
      setMedicalSpecialityTypeName("");
    }
  };

  /*** 
  @purpose : Handle BU change
  @Parameter : {value}
  **/
  const handleBUChange = async (value) => {
    setDivisionID("");
    setDivision("");
    setBranchID("");
    setBranch("");
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setDivisionLoading(true);
      let data = value.label;
      setBuValue(data);
      let id = value.value;
      setBuID(id);
      await fetchDivisionList(id).then((res) => {
        setDivisionLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else {
      setDivisionLoading(false);
      setBuID("");
      setBuValue("");
      setDivisionID("");
      setDivision("");
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setDivisionList([]);
    }
  };

  /*** 
  @purpose : Handle division change
  @Parameter : {value}
  **/
  const handleDivisionChange = async (value) => {
    setBranchID("");
    setBranch("");
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setBranchLoading(true);
      let data = value.label;
      setDivision(data);
      let id = value.value;
      setDivisionID(id);
      await fetchBranchList({ buID: buID, divisionID: id }).then((res) => {
        setBranchLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.branchID, label: item.orgName });
        }
        setBranchList(list);
      });
    } else {
      setBranchLoading(false);
      setDivisionID("");
      setDivision("");
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setDivisionList([]);
      setBranchList([]);
      setSalesOfficeList([]);
    }
  };

  /*** 
  @purpose : Handle branch change
  @Parameter : {}
  **/
  const handleBranchChange = async (value) => {
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setSalesOfficeLoading(true);
      let data = value.label;
      setBranch(data);
      let id = value.value;
      setBranchID(id);
      await fetchSalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: id,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      setSalesOfficeLoading(false);
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setSalesOfficeList([]);
    }
  };

  /*** 
  @purpose : Handle sales office change
  @Parameter : {value}
  **/
  const handleSalesOfficeChange = async (value) => {
    if (value) {
      setSalesOffice(value.label);
      setSalesOfficeID(value.value);
    } else {
      setSalesOffice("");
      setSalesOfficeID("");
    }
  };

  /*** 
  @purpose : Handle checkbox
  @Parameter : {e}
  **/
  const handleCheckbox = (e) => {
    let tempListing = [...mrList];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else if (e.target.value !== "checkAll") {
      tempListing.forEach((item) => {
        if (item.wwid == e.target.value) {
          item.isChecked = e.target.checked;
        }
      });
    }
    setMRList(tempListing);
    setAllChecked(checkedAll);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleEmployeeSort = (col) => {
    let list = [...mrList];
    list.sort((a, b) => {
      if (`a.${col}` < `b.${col}`) {
        return -1;
      }
      if (`a.${col}` > `b.${col}`) {
        return 1;
      }
      return 0;
    });
    setMRList(list);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleSortingData = (obj) => {
    obj.column === "customerCode" && setSortCode(obj.sortOrder);
    obj.column === "facilityNameLocal" && setSortFacilityName(obj.sortOrder);
    obj.column === "address" && setSortAddress(obj.sortOrder);
    obj.column === "tel" && setSortTelephone(obj.sortOrder);
    obj.column === "customerTypeName" && setSortCustomerType(obj.sortOrder);
    obj.column === "facilityClassName" && setSortFacilityClass(obj.sortOrder);
    let list = compareBySortedData(obj);
    setOrganizationList(list);
  };

  /*** 
  @purpose : Compare sorted data
  @Parameter : {}
  **/
  const compareBySortedData = (obj) => {
    const sorted = organizationList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  const [text, setText] = useState({});
  const [language, setLang] = useState({});

  useEffect(() => {
    if (sessionStorage.getItem("translation")) {
      setText(JSON.parse(sessionStorage.getItem("translation")));
    }
    if (sessionStorage.getItem("translation")) {
      setLang(sessionStorage.getItem("Language"));
    }
  }, [sessionStorage.getItem("Language"),sessionStorage.getItem("translation")]);

  const [finalText, setfinalText] = useState("");
  const [finalText2, setfinalText2] = useState("");
  const [timer, setTimer] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimer(true);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const searchText = "customerinquiry";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if (filteredTexts[language]) {
      setfinalText(filteredTexts[language]);
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [
    language,
    text,
    timer,
    maintenance,
    sessionStorage.getItem("Language"),
    sessionStorage.getItem("translation"),
  ]);

  return (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb
            finalText2={finalText2}
            finalText={finalText}
            routes={routes}
          />
          <h2>{lang("Menu.organizationCustomer")}</h2>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {lang("organizationDetails.organizationCustomerSearch")}
              </Accordion.Header>
              <Accordion.Body>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("OrganizationMenu.kanjiFacilityName")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={facilityKanjiName}
                              maxLength="100"
                              pattern="/^[A-Za-z]+$/"
                              onChange={(e) => {
                                setFacilityKanjiName(e.target.value);
                              }}
                            />
                          </div>
                          {errors.facilityKanjiName && (
                            <p className="error-text">
                              {lang(`${errors.facilityKanjiName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={facilityKanaName}
                              maxLength="100"
                              onChange={(e) =>
                                setFacilityKanaName(e.target.value)
                              }
                            />
                          </div>
                          {errors.facilityKanaName && (
                            <p className="error-text">
                              {lang(`${errors.facilityKanaName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("OrganizationMenu.integratedCustomerCode")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={integratedCustomerCode}
                              maxLength="10"
                              onChange={(e) =>
                                setIntegratedCustomerCode(e.target.value)
                              }
                            />
                          </div>
                          {errors.integratedCustomerCode && (
                            <p className="error-text">
                              {lang(`${errors.integratedCustomerCode}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("OrganizationMenu.address")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                            </label>
                            <Select
                              className="ant-select"
                              options={prefectureList}
                              allowClear={true}
                              onChange={handleStateChange}
                              loading={prefectureLoading}
                              placeholder={lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                              showSearch={
                                prefectureList && prefectureList.length > 0
                                  ? true
                                  : false
                              }
                              optionFilterProp="label"
                              labelInValue
                            />
                          </div>
                        </div>
                        <div className="col-xl-9 col-md-8">
                          <div className="form-group">
                            <label>
                              {lang("parentChildFacilityMaintenance.city")}
                            </label>
                            {/* <Select
                              mode="multiple"
                              placeholder="Please select"
                              onChange={handleCityChange}
                              options={cityData}
                              value={cityID}
                              disabled={prefectureID ? false : true}
                            /> */}
                            <Select
                              value={cityID}
                              disabled={prefectureID ? false : true}
                              mode="multiple"
                              options={cityData}
                              onChange={handleCityChange}
                              placeholder="Please select"
                              showSearch
                              optionFilterProp="label"
                              labelInValue
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>{lang("OrganizationMenu.freeText")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={freeAddress}
                              maxLength="100"
                              onChange={(e) => setFreeAddress(e.target.value)}
                            />
                          </div>
                          {errors.freeAddress && (
                            <p className="error-text">
                              {lang(`${errors.freeAddress}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        {lang("OrganizationMenu.moreConditions")}
                      </Accordion.Header>
                      <Accordion.Body>
                          <div className="horizon-form">
                            <div className="custom-3">
                              <label>
                                {lang("OrganizationMenu.allocatedSalesOffice")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      allowClear={true}
                                      placeholder={lang(
                                        "OrganizationMenu.allocatedSalesOffice"
                                      )}
                                      loading={allocatedSalesLoading}
                                      options={allocatedSalesOfficeList}
                                      onChange={
                                        handleAllocatedSalesOfficeChange
                                      }
                                      showSearch={
                                        allocatedSalesOfficeList &&
                                        allocatedSalesOfficeList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      labelInValue
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="horizon-form">
                            <div className="custom-3">
                              <label>
                                {lang("OrganizationMenu.allocatedMR")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="mrs-main">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mrs-box">
                                      <ul className="selected-mrs">
                                        {selectedMRList &&
                                          selectedMRList.map((emp) => {
                                            return (
                                              <li key={emp.wwid}>
                                                {emp.mrName}
                                                <em
                                                  className="bx bx-x"
                                                  onClick={() =>
                                                    removeEmployee(emp)
                                                  }
                                                ></em>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                      <button
                                        className="btn btn-primary"
                                        onClick={openEmployeeSearch}
                                      >
                                        {lang("Buttons.select")}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className={activeEmployeeSearch}>
                                  <h3>
                                    {lang("organizationDetails.employeeSearch")}
                                  </h3>
                                  <div className="row">
                                    <div className="col-xl-3 col-md-6">
                                      <div className="form-group">
                                        <label>
                                          {lang(
                                            "territoryDefinitionMaintenance.BU"
                                          )}
                                        </label>
                                        <Select
                                          className="ant-select"
                                          options={buList}
                                          onChange={handleBUChange}
                                          value={buID ? {
                                            value: buID,
                                            label: buValue,
                                          } : undefined}
                                          allowClear={buID ? true : false}
                                          showSearch={
                                            buList && buList.length > 0
                                              ? true
                                              : false
                                          }
                                          optionFilterProp="label"
                                          labelInValue
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="form-group">
                                        <label>
                                          {lang(
                                            "territoryDefinitionMaintenance.division"
                                          )}
                                        </label>
                                        <Select
                                          className="ant-select"
                                          options={divisionList}
                                          value={divisionID ? {
                                            value: divisionID,
                                            label: division,
                                          } : undefined}
                                          loading={divisionLoading}
                                          onChange={handleDivisionChange}
                                          disabled={buID ? false : true}
                                          allowClear={
                                            divisionID ? true : false
                                          }
                                          showSearch={
                                            divisionList &&
                                            divisionList.length > 0
                                              ? true
                                              : false
                                          }
                                          optionFilterProp="label"
                                          labelInValue
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="form-group">
                                        <label>
                                          {lang(
                                            "territoryDefinitionMaintenance.branch"
                                          )}
                                        </label>
                                        <Select
                                          className="ant-select"
                                          options={branchList}
                                          loading={branchLoading}
                                          value={branchID ? {
                                            value: branchID,
                                            label: branch,
                                          } : undefined}
                                          onChange={handleBranchChange}
                                          disabled={divisionID ? false : true}
                                          allowClear={branchID ? true : false}
                                          showSearch={
                                            branchList && branchList.length > 0
                                              ? true
                                              : false
                                          }
                                          optionFilterProp="label"
                                          labelInValue
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="form-group">
                                        <label>
                                          {lang(
                                            "territoryDefinitionMaintenance.salesOffice"
                                          )}
                                        </label>
                                        <Select
                                          className="ant-select"
                                          options={salesOfficeList}
                                          loading={salesOfficeLoading}
                                          value={salesOfficeID ? {
                                            value: salesOfficeID,
                                            label: salesOffice,
                                          } : undefined}
                                          onChange={handleSalesOfficeChange}
                                          disabled={branchID ? false : true}
                                          allowClear={
                                            salesOfficeID ? true : false
                                          }
                                          showSearch={
                                            salesOfficeList &&
                                            salesOfficeList.length > 0
                                              ? true
                                              : false
                                          }
                                          optionFilterProp="label"
                                          labelInValue
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group inline-input">
                                        <label>
                                          {lang(
                                            "territoryDefinitionMaintenance.wwid"
                                          )}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={wwid}
                                          onChange={(e) =>
                                            setWWID(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="col-md-6">
                                      <div className="form-group inline-input">
                                        <label>
                                          {lang(
                                            "parentChildFacilityMaintenance.name"
                                          )}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={name}
                                          onChange={(e) =>
                                            setName(e.target.value)
                                          }
                                        />
                                      </div>
                                      <p className="error-text">
                                        {employeeErrors.name}
                                      </p>
                                    </div>
                                    <div className="col-12 mb-4">
                                      <button
                                        className="btn btn-primary"
                                        onClick={handleEmployeeSearch}
                                      >
                                        {lang("Buttons.apply")}
                                      </button>
                                      <span className="common-notice inline ml-4">
                                        {applyNotice && lang('annotations.applyNotice')                                          }
                                      </span>
                                    </div>
                                  </div>

                                  {mrList.length > 0 && (
                                    <>
                                      <p className="record-total">
                                        {lang(
                                          "territoryDefinitionMaintenance.totalRecords"
                                        )}{" "}
                                        - {mrList.length} / {totalEmployees}
                                      </p>
                                      <div
                                        ref={employeeContainerRef}
                                        className="table-responsive esearch-table hover-table"
                                      >
                                        <table
                                          className="table"
                                          aria-describedby="table"
                                        >
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                <div className="custom-checkbox d-inline-block">
                                                  <input
                                                    type="checkbox"
                                                    id="tc1"
                                                    value="checkAll"
                                                    name="checkAll"
                                                    checked={allChecked}
                                                    onChange={handleCheckbox}
                                                  />
                                                  <label htmlFor="tc1"></label>
                                                </div>
                                              </th>
                                              <th
                                                scope="col"
                                                onClick={() =>
                                                  handleEmployeeSort(
                                                    "divisionName"
                                                  )
                                                }
                                              >
                                                <div className="cursor-pointer">
                                                  {lang(
                                                    "territoryDefinitionMaintenance.division"
                                                  )}
                                                  <em className="bx bxs-sort-alt"></em>
                                                </div>
                                              </th>
                                              <th
                                                scope="col"
                                                onClick={() =>
                                                  handleEmployeeSort(
                                                    "branchName"
                                                  )
                                                }
                                              >
                                                <div className="cursor-pointer">
                                                  {lang(
                                                    "territoryDefinitionMaintenance.branch"
                                                  )}
                                                  <em className="bx bxs-sort-alt"></em>
                                                </div>
                                              </th>
                                              <th
                                                scope="col"
                                                onClick={() =>
                                                  handleEmployeeSort(
                                                    "salesofficeName"
                                                  )
                                                }
                                              >
                                                <div className="cursor-pointer">
                                                  {lang(
                                                    "territoryDefinitionMaintenance.salesOffice"
                                                  )}
                                                  <em className="bx bxs-sort-alt"></em>
                                                </div>
                                              </th>
                                              <th
                                                scope="col"
                                                onClick={() =>
                                                  handleEmployeeSort("wwid")
                                                }
                                              >
                                                <div className="cursor-pointer">
                                                  {lang(
                                                    "territoryDefinitionMaintenance.wwid"
                                                  )}
                                                  <em className="bx bxs-sort-alt"></em>
                                                </div>
                                              </th>
                                              <th
                                                scope="col"
                                                onClick={() =>
                                                  handleEmployeeSort("mrName")
                                                }
                                              >
                                                <div className="cursor-pointer">
                                                  {lang(
                                                    "parentChildFacilityMaintenance.name"
                                                  )}
                                                  <em className="bx bxs-sort-alt"></em>
                                                </div>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {mrList &&
                                              mrList.map((mr, key) => {
                                                return (
                                                  <tr key={key}>
                                                    <td>
                                                      <div className="custom-checkbox d-inline-block">
                                                        <input
                                                          type="checkbox"
                                                          id={mr.wwid}
                                                          name={mr.wwid}
                                                          value={mr.wwid}
                                                          checked={mr.isChecked}
                                                          onChange={
                                                            handleCheckbox
                                                          }
                                                          key={mr.wwid}
                                                        />
                                                        <label
                                                          htmlFor={mr.wwid}
                                                        ></label>
                                                      </div>
                                                    </td>
                                                    <td>{mr.divisionName}</td>
                                                    <td>{mr.branchName}</td>
                                                    <td>
                                                      {mr.salesofficeName}
                                                    </td>
                                                    <td>{mr.wwid}</td>
                                                    <td>{mr.mrName}</td>
                                                  </tr>
                                                );
                                              })}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="mt-2 text-right">
                                        <button
                                          className="btn btn-primary"
                                          onClick={addEmployeeSearch}
                                        >
                                          {lang("Buttons.select")}
                                        </button>
                                      </div>
                                    </>
                                  )}

                                  {mrList.length === 0 &&
                                    employeeLoading === true && (
                                      <Spinner animation="border" />
                                    )}
                                  {noEmployeeData && (
                                    <div className="noData">
                                      {lang("errorMessages.NO_DATA")}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="horizon-form">
                            <div className="custom-3">
                              <label>{lang("OrganizationMenu.tel")}</label>
                            </div>
                            <div className="custom-9">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={telephone}
                                      maxLength="15"
                                      onChange={(e) =>
                                        setTelephone(e.target.value)
                                      }
                                    />
                                  </div>
                                  <p className="error-text">
                                    {errors.telephone}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="horizon-form">
                            <div className="custom-3">
                              <label>
                                {lang("OrganizationMenu.classifications")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={customerTypeList}
                                      placeholder={lang(
                                        "organizationDetails.customerType"
                                      )}
                                      allowClear={true}
                                      loading={customerTypeLoading}
                                      showSearch={
                                        customerTypeList &&
                                        customerTypeList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleCustomerTypeChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={ultmarcRecordList}
                                      placeholder={lang(
                                        "errorMessages.ultmarcRecordID"
                                      )}
                                      allowClear={true}
                                      loading={ultmarcRecordLoading}
                                      showSearch={
                                        ultmarcRecordList &&
                                        ultmarcRecordList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleUltmarcRecordChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={hundredBedsList}
                                      placeholder={lang(
                                        "organizationDetails.hundredBedsType"
                                      )}
                                      allowClear={true}
                                      loading={hundredBedsLoading}
                                      showSearch={
                                        hundredBedsList &&
                                        hundredBedsList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleBedChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={facilityFunctionList}
                                      placeholder={lang(
                                        "organizationDetails.facilityFunctionType"
                                      )}
                                      allowClear={true}
                                      loading={facilityFunctionLoading}
                                      showSearch={
                                        facilityFunctionList &&
                                        facilityFunctionList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleFacilityFunctionChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={facilityClassList}
                                      placeholder={lang(
                                        "organizationDetails.facilityClassType"
                                      )}
                                      allowClear={true}
                                      loading={facilityClassLoading}
                                      showSearch={
                                        facilityClassList &&
                                        facilityClassList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleFacilityClassChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={ultmarcHospitalList}
                                      placeholder={lang(
                                        "organizationDetails.ultmarcHospitalType"
                                      )}
                                      allowClear={true}
                                      loading={ultmarcHospitalLoading}
                                      showSearch={
                                        ultmarcHospitalList &&
                                        ultmarcHospitalList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleUltmarcHospitalChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="horizon-form">
                            <div className="custom-3">
                              <label>
                                {lang("OrganizationMenu.speciality")}
                              </label>
                            </div>
                            <div className="custom-9">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      showSearch={
                                        ultmarcFacilitySuperTypeList &&
                                        ultmarcFacilitySuperTypeList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      options={ultmarcFacilitySuperTypeList}
                                      placeholder={lang(
                                        "errorMessages.ultmarcFacilityTypeOne"
                                      )}
                                      allowClear={
                                        ultmarcFacilitySuperTypeID
                                          ? true
                                          : false
                                      }
                                      onChange={
                                        handleUltmarcFacilitySuperTypeChange
                                      }
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={ultmarcFacilityTypeList}
                                      value={ultmarcFacilityTypeID ? {
                                        value: ultmarcFacilityTypeID,
                                        label: ultmarcFacilityTypeName,
                                      } : undefined}
                                      allowClear={
                                        ultmarcFacilityTypeID ? true : false
                                      }
                                      loading={ultmarcFacilityTwoLoading}
                                      disabled={
                                        ultmarcFacilitySuperTypeID === ""
                                      }
                                      showSearch={
                                        ultmarcFacilityTypeList &&
                                        ultmarcFacilityTypeList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={handleUltmarcFacilityTypeChange}
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={medicalSpecialitySuperTypeList}
                                      placeholder={lang(
                                        "errorMessages.medicalSpecialityOne"
                                      )}
                                      // value={{value: medicalSpecialitySuperTypeID, label: medicalSpecialitySuperTypeName}}
                                      allowClear={
                                        medicalSpecialitySuperTypeID
                                          ? true
                                          : false
                                      }
                                      loading={specialityOneLoading}
                                      showSearch={
                                        medicalSpecialitySuperTypeList &&
                                        medicalSpecialitySuperTypeList.length >
                                          0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      onChange={
                                        handleMedicalSpecialitySuperTypeChange
                                      }
                                      labelInValue
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <Select
                                      className="ant-select"
                                      options={medicalSpecialityTypeList}
                                      value={medicalSpecialityTypeID ? {
                                        value: medicalSpecialityTypeID,
                                        label: medicalSpecialityTypeName,
                                      } : undefined}
                                      allowClear={
                                        medicalSpecialityTypeID ? true : false
                                      }
                                      loading={specialityTwoLoading}
                                      showSearch={
                                        medicalSpecialityTypeList &&
                                        medicalSpecialityTypeList.length > 0
                                          ? true
                                          : false
                                      }
                                      optionFilterProp="label"
                                      disabled={
                                        medicalSpecialitySuperTypeID === ""
                                      }
                                      onChange={
                                        handleMedicalSpecialityTypeChange
                                      }
                                      labelInValue
                                    />
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>                  <div className="steps-action1 mt-4">
                    {isLoading && <Spinner animation="border" />}
                    <button
                      className="btn btn-primary"
                      onClick={handleOrganizationSearch}
                      disabled={isLoading}
                    >
                      {lang("Buttons.search")}
                    </button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          {organizationList.length > 0 && loading === false && (
            <p className="record-total">
              {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
              {organizationList && organizationList.length} /{" "}
              {totalOrgCustomers}
            </p>
          )}
          {organizationList.length > 0 && loading === false && (
            <>
              <div
                // ref={containerRef}
                className="table-responsive mb-0 hover-table max-height"
              >
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerCode",
                            sortOrder: sortCode === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildFacilityMaintenance.code")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "facilityNameLocal",
                            sortOrder:
                              sortFacilityName === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.facilityName")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "address",
                            sortOrder: sortAddress === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.address")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "tel",
                            sortOrder:
                              sortTelephone === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.tel")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerTypeName",
                            sortOrder:
                              sortCustomerType === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.customerType")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "facilityClassName",
                            sortOrder:
                              sortFacilityClass === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.facilityClassType")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {organizationList &&
                      organizationList.map((org, key) => {
                        let facility = "";
                        org &&
                          facilityClassList &&
                          facilityClassList.map((fac) => {
                            if (fac.value === org.facilityClassType) {
                              facility = fac.label;
                            }
                          });

                        return (
                          org && (
                            <tr
                              key={org.orgCustID}
                              onClick={() =>
                                handleOrganizationDetails(org.orgCustID)
                              }
                            >
                              <td>{org && org.customerCode}</td>
                              <td>{org && org.facilityNameLocal}</td>
                              <td>{org && org.address}</td>
                              <td>{org.tel}</td>
                              <td>{org.customerTypeName}</td>
                              <td>{org.facilityClassName}</td>
                            </tr>
                          )
                        );
                      })}
                  </tbody>
                </table>
              </div>
              {organizationList.length < totalOrgCustomers && (
                <div className="steps-action1 mt-4">
                  {lazyLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={loadRecords}
                    disabled={lazyLoading}
                  >
                    {lang("Buttons.loadMore")}
                  </button>
                </div>
              )}
            </>
          )}
          {organizationList.length === 0 && loading === true && (
            <Spinner animation="border" />
          )}
          {noData && (
            <div className="noData">{lang("errorMessages.NO_DATA")}</div>
          )}
        </>
      )}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {};
};
export default OrganizationCustomer;